<div class="header-bar">
  <h1>Movement Transaction Lines Report</h1>
</div>
<div class="">
  <div class="">
    <div class="content-container">
      <div class="">
        <form (ngSubmit)="search()" style="width: 100%">
          <div class="ui-g filterPanel form-group">
            <div class="ui-g-12 ui-md-3 ui-lg-3">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.dateFrom.value"
                  (ngModelChange)="onDateChange($event)"
                  name="createDateFrom"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label title="Start date of report">Date Created From</label>
              </span>
            </div>

            <div class="ui-g-12 ui-md-3 ui-lg-3">
              <span class="md-inputfield filterItem">
                <p-calendar
                  [(ngModel)]="filterVal.filters.dateTo.value"
                  (ngModelChange)="onDateChange($event)"
                  name="createDateTo"
                  dateFormat="dd/mm/yy"
                ></p-calendar>
                <label title="End Date of report - defaults to end of day">Date Created To</label>
              </span>
            </div>
            <div class="ui-g-12 ui-md-3 ui-lg-2">
              <span
                pTooltip="Either use the date the job was completed or date the transaction line was created"
              >
                <span class="first">Use Job Completed Date </span>
                <p-inputSwitch
                  [(ngModel)]="filterVal.filters.useJobCompletedDate.value"
                  name="useJobCompletedDate"
                  (onChange)="handleDateModeChange($event)"
                ></p-inputSwitch>
              </span>
            </div>
            <div class="ui-g-12 ui-md-3 ui-lg-2">
              <span pTooltip="Include Engineius additional costs?">
                <span class="first">Engineius Transactions </span>
                <p-inputSwitch
                  [(ngModel)]="filterVal.filters.includeEngineiusTransactions.value"
                  name="includeEngineiusTransactions"
                  (onChange)="handleIncludeEngineiusChange($event)"
                ></p-inputSwitch>
              </span>
            </div>

            <div class="ui-g-12 ui-md-3 ui-lg-2">
              <span pTooltip="Show only uninvoiced transactions">
                <span class="first">Uninvoiced Transactions </span>
                <p-inputSwitch
                  [(ngModel)]="filterVal.filters.uninvoicedTransactions.value"
                  name="uninvoicedTransactions"
                  (onChange)="handleUninvoicedTransactions($event)"
                ></p-inputSwitch>
              </span>
            </div>

            <div class="ui-g-12 ui-grid-row">
              <div class="ui-g-12 ui-md-4 ui-lg-4">
                <p-multiSelect
                  name="customers"
                  [options]="customers"
                  [(ngModel)]="filterVal.filters.customerIdList.value"
                  styleClass="filterItem"
                  defaultLabel="Customers"
                ></p-multiSelect>
              </div>

              <div class="ui-g-12 ui-md-4 ui-lg-4">
                <p-multiSelect
                  name="additionalChargeTypes"
                  [options]="additionalChargeTypes"
                  [(ngModel)]="filterVal.filters.additionalChargeTypeIdList.value"
                  styleClass="filterItem"
                  defaultLabel="Additional Charge Types"
                ></p-multiSelect>
              </div>

              <div class="ui-g-12 ui-md-4 ui-lg-4">
                <button
                  pButton
                  type="button"
                  label="Clear"
                  class="ui-button btn-to-right"
                  (click)="clearFilter(dt)"
                ></button>
                <button
                  pButton
                  type="submit"
                  label="Search"
                  class="ui-button btn-to-right"
                ></button>
              </div>
            </div>
          </div>

          <div class="ui-g filterPanel confirmFilterPanel">
            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <p-radioButton
                name="confirmationFilter"
                value="showAll"
                [(ngModel)]="radioButtonVal"
                (ngModelChange)="handleAllFilterChange($event)"
                label="Show all"
                inputId="1"
              ></p-radioButton>
            </div>
            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <p-radioButton
                name="confirmationFilter"
                value="showConfirmed"
                [(ngModel)]="radioButtonVal"
                (ngModelChange)="handleConfirmedFilterChange($event)"
                label="Confirmed only"
                inputId="2"
              ></p-radioButton>
            </div>
            <div class="ui-g-12 ui-md-4 ui-lg-4">
              <p-radioButton
                name="confirmationFilter"
                value="showUnconfirmed"
                [(ngModel)]="radioButtonVal"
                (ngModelChange)="handleUnconfirmedFilterChange($event)"
                label="Unconfirmed only"
                inputId="3"
              ></p-radioButton>
            </div>
          </div>
        </form>

        <p-dialog
          header="Verify action"
          *ngIf="verifyUnconfirmVisible"
          [(visible)]="verifyUnconfirmVisible"
          [responsive]="true"
          [modal]="true"
          [style]="{ width: '300px' }"
          [closable]="false"
        >
          <form #confirmationNotesForm="ngForm">
            <div class="ui-grid-row" style="margin-bottom: 20px">
              <div class="ui-g-12">This action will unconfirm the job, ok to continue?<br /></div>
            </div>
            <div class="ui-grid-row" style="float: right">
              <button
                type="button"
                class="green-btn"
                pButton
                icon="fa ui-icon-check"
                (click)="saveConfirmation()"
                label="Continue"
              ></button>
              <button
                type="button"
                pButton
                icon="fa ui-icon-close"
                label="Cancel"
                (click)="cancelConfirmation()"
              ></button>
            </div>
          </form>
        </p-dialog>

        <p-dialog
          header="Confirmation notes"
          *ngIf="confirmationNotesVisible"
          [(visible)]="confirmationNotesVisible"
          [responsive]="true"
          [modal]="true"
          [style]="{ width: '450px' }"
          [closable]="false"
        >
          <form #confirmationNotesForm="ngForm">
            <div class="ui-grid ui-grid-responsive ui-fluid">
              <div class="ui-grid-col-8">
                <textarea
                  name="confirmNotes"
                  [(ngModel)]="transactionLineItem.notes"
                  pInputTextarea
                  style="width: 100%"
                  maxlength="4000"
                  placeholder="Notes"
                ></textarea>
                <!-- [(ngModel)]="rowData.notes"-->
              </div>
            </div>
            <div class="ui-grid-row">
              <div class="ui-g-12"></div>
            </div>
            <div class="ui-grid-row" style="float: right">
              <button
                type="button"
                class="green-btn"
                pButton
                icon="fa ui-icon-check"
                (click)="saveConfirmation()"
                label="Save"
              ></button>
              <button
                type="button"
                pButton
                icon="fa ui-icon-close"
                label="Close"
                (click)="saveConfirmation()"
              ></button>
            </div>
          </form>
        </p-dialog>

        <p-treeTable
          #dt
          [value]="page.items"
          [columns]="cols"
          [paginator]="true"
          [rows]="10"
          [lazy]="true"
          (onLazyLoad)="onGridLazyLoad($event)"
          [totalRecords]="page.total"
          [loading]="isLoading"
          [resizableColumns]="true"
          [rowsPerPageOptions]="[5, 10, 20, 50, 100]"
          class="zebra"
          [responsive]="true"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                *ngFor="let col of columns"
                [ttSortableColumn]="col.field"
                ttResizableColumn
                [style.width]="col.width"
              >
                {{ col.header }}
                <p-treeTableSortIcon
                  *ngIf="
                    col.field != 'confirmed' &&
                    col.field != 'invoiceNumber' &&
                    col.field != 'invoiceDate'
                  "
                  [field]="col.field"
                ></p-treeTableSortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr
              [ngClass]="{
                'order-lines-row': rowData.transactionLineType == TransactionLineType.CustomerCost,
                'transaction-lines-row': rowData.transactionLineType == TransactionLineType.Expense,
                'job-lines-row': rowData.transactionLineType == TransactionLineType.SupplierPayment
              }"
              (click)="transactionLineItem = rowData"
            >
              <td
                *ngFor="let col of columns"
                [ngSwitch]="col.field"
                [ngClass]="{
                  'transaction-report-td': true,
                  'profit-loss-value-td': col.field == 'profitLossPercentage'
                }"
              >
                <div *ngSwitchCase="'confirmed'" class="job-confirmation-status">
                  <p-checkbox
                    #confirmedCheckbox
                    *ngIf="rowNode.level === 0"
                    type="checkbox"
                    binary="true"
                    (ngModelChange)="confirmedChange(rowData, confirmedCheckbox)"
                    [(ngModel)]="rowData.confirmed"
                    name="chkConfirmed"
                  >
                  </p-checkbox>
                  <img
                    *ngIf="
                      rowNode.level === 0 &&
                      rowData.notes != null &&
                      rowData.confirmed &&
                      rowData.confirmedByUser != null
                    "
                    class="job-confirmation-note-image"
                    src="{{ noteImageUrl }}"
                    max-width="100%"
                    max-height="100%"
                    alt="note"
                    pTooltip="Confirmed by {{ rowData.confirmedByUser }} on {{
                      rowData.confirmedDateTime | date : 'dd/MM/yyyy HH:mm'
                    }} [{{ rowData.notes }}]"
                    tooltipPosition="right"
                  />
                </div>

                <div *ngSwitchCase="'transactionType'">{{ rowData[col.field] }}</div>

                <div *ngSwitchCase="'completedDate'">
                  <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
                  {{ rowData[col.field] | datex : 'DD MMM YYYY' }}
                </div>
                <div *ngSwitchCase="'jobRef'">
                  <a href="/app/jobscreen/{{ rowData.id }}" target="_blank">{{
                    rowData[col.field]
                  }}</a>
                </div>
                <div *ngSwitchCase="'orderRef'">
                  <a href="/app/jobscreen/{{ rowData.id }}" target="_blank">{{
                    rowData[col.field]
                  }}</a>
                </div>
                <ng-container *ngSwitchCase="'originalCustomerPrice'">
                  <div
                    *ngIf="
                      rowData.transactionLineType == TransactionLineType.CustomerCost ||
                      rowData.transactionLineType == TransactionLineType.Summary
                    "
                  >
                    {{ rowData[col.field] | currency : 'GBP' : 'symbol' : '1.2-2' }}
                  </div>
                </ng-container>
                <div *ngSwitchCase="'customerPrice'">
                  {{ rowData[col.field] | currency : 'GBP' : 'symbol' : '1.2-2' }}
                </div>
                <div *ngSwitchCase="'supplierPrice'">
                  {{ rowData[col.field] | currency : 'GBP' : 'symbol' : '1.2-2' }}
                </div>
                <div *ngSwitchCase="'profitLossAmount'">
                  {{ rowData[col.field] | currency : 'GBP' : 'symbol' : '1.2-2' }}
                </div>
                <div *ngSwitchCase="'profitLossPercentage'">
                  <div [ngClass]="getProfitLossIndicatorClass(rowData.profitLossPercentage)">
                    {{
                      rowData[col.field] !== null ? (rowData[col.field] | percent : '1.2-2') : ''
                    }}
                  </div>
                </div>
                <div *ngSwitchDefault title="{{ rowData[col.field] }}">
                  {{ rowData[col.field] }}
                </div>
                <div *ngSwitchCase="'invoiceDate'">
                  {{ rowData[col.field] | date : 'dd/MM/yyyy' }}
                </div>
              </td>
            </tr>
          </ng-template>
        </p-treeTable>
      </div>
      <div class="ui-g-12" style="height: 40px; margin-top: 20px">
        <button
          type="button"
          pButton
          icon="fa ui-icon-file-download"
          label="Download"
          class="ui-button btn-to-right"
          (click)="checkDownloadReport()"
          [disabled]="page.total == 0"
        ></button>
      </div>
    </div>
  </div>
</div>
<p-dialog
  header="Downloading Report"
  [responsive]="true"
  [closable]="true"
  (onHide)="cancelReport()"
  [(visible)]="showProgressBar"
  [modal]="true"
  [style]="{ width: '300px' }"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
</p-dialog>

<ng-template #loading>Loading...</ng-template>
